import React, { useEffect, useState, useContext } from 'react';
import './detailStyle.css';
import { Spinner, Modal, Button } from 'react-bootstrap';
import { useFetch } from '../../../components/hooks/useFetch';
import { Prefix } from '../../../services/prefix';
import { Context } from '../../../services/context';
import DetailsMonitoring from '../../components/detailsMonitoring/detailsMonitoring';
import { MonitoringCard } from "../../pages/sensorsDashboard/components/MonitoringCard";
import { useHistory, useLocation } from "react-router-dom";
import { FiArrowLeft } from 'react-icons/fi';
import SidebarSisboard from '../../../components/sidebar/sidebar';
import Topbar from '../../../components/topbar/topbar';
import { ColCard, RowCards } from './styled';
import ChartEnergyComponent from './chartenergy';

const getPriority = (situation) => {
    const priorityMap = { DANGER: 1, WARNING: 2, DARK: 3, SUCCESS: 4 };
    return priorityMap[situation] || 99;
};

const DetailClient = () => {
    const history = useHistory();
    const location = useLocation();
    const customer = location.state?.customer;

    const { viewSismogran, setViewSismogran } = useContext(Context);

    const [sensorFilter, setSensorFilter] = useState('ALL');
    const [expandedUnits, setExpandedUnits] = useState({});
    const [roomsByUnit, setRoomsByUnit] = useState({});
    const [loadingRooms, setLoadingRooms] = useState({});
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [full, setFull] = useState(true);
    const [fullScreen, setFullScreen] = useState(false);

    const unitsUrl = customer
        ? `${Prefix.replace(/[\\"]/g, '')}/sismogran/map/units?id_customer=${customer.id}`
        : null;

    const { data } = useFetch(unitsUrl);

    const openedUnitId = Object.keys(expandedUnits).find(id => expandedUnits[id]);

    const roomsUrl = openedUnitId
        ? `${Prefix.replace(/[\\"]/g, '')}/sismogran/map/units/${openedUnitId}/rooms`
        : null;

    const roomsFetch = useFetch(roomsUrl);

    useEffect(() => {
        if (!data?.models) return;

        const sorted = [...data.models].sort(
            (a, b) => getPriority(a.situation) - getPriority(b.situation)
        );

        setCustomers(sorted);
        setLoading(false);
    }, [data]);

    useEffect(() => {
        if (!openedUnitId) return;
        if (!roomsFetch.data?.models) return;

        setRoomsByUnit(prev => ({
            ...prev,
            [openedUnitId]: roomsFetch.data.models
        }));

        setLoadingRooms(prev => ({ ...prev, [openedUnitId]: false }));
    }, [openedUnitId, roomsFetch.data]);

    if (!customer) return null;

    const toggleUnit = (unitId) => {
        setExpandedUnits(prev => {
            const open = !prev[unitId];

            if (open && !roomsByUnit[unitId]) {
                setLoadingRooms(l => ({ ...l, [unitId]: true }));
            }

            return { ...prev, [unitId]: open };
        });
    };

    const filterSensorsForDisplay = (sensors = []) => {
        if (sensorFilter === 'ALL') return sensors;
        return sensors.filter(sensor => sensor.status?.status === sensorFilter);
    };

    const filterEquipmentForDisplay = (equipment = []) => {
        return equipment.filter(item =>
            filterSensorsForDisplay(item.sensors || []).length > 0
        );
    };

    const totalSituationsGlobal = { SUCCESS: 0, WARNING: 0, DANGER: 0, DARK: 0 };

    customers.forEach(unit => {
        if (!unit.situations) return;

        Object.keys(totalSituationsGlobal).forEach(status => {
            totalSituationsGlobal[status] += unit.situations[status] || 0;
        });
    });

    return (
        <div className={`wrapper d-flex align-items-stretch ${fullScreen ? 'fullscreen-mode' : ''}`}>
            {!fullScreen && <SidebarSisboard />}
            <div id="content" className={fullScreen ? 'full-content' : ''}>
                {!fullScreen && <Topbar />}

                <div className="content_all">
                    <div className="customer-detail-header-full">
                        <div className="header-left">
                            <Button
                                variant="outline-primary"
                                className="back-btn"
                                onClick={() => history.goBack()}
                            >
                                <FiArrowLeft size={18} style={{ marginRight: 8 }} />
                                Voltar
                            </Button>
                        </div>

                        <div className="header-info">
                            <h2>{customer.fantasy_name || customer.name}</h2>
                            {customer.message && <p className="customer-msg">{customer.message}</p>}
                        </div>

                        <div className="chip-container">
                            {['SUCCESS', 'WARNING', 'DANGER', 'DARK'].map(status => (
                                <div
                                    key={status}
                                    className={`chip ${status.toLowerCase()} ${sensorFilter === status ? 'active-item' : ''}`}
                                    onClick={() =>
                                        setSensorFilter(prev => prev === status ? 'ALL' : status)
                                    }
                                >
                                    <img
                                        src={`/media/icons/${status === 'SUCCESS'
                                            ? 'green-light'
                                            : status === 'WARNING'
                                                ? 'yellow-light'
                                                : status === 'DANGER'
                                                    ? 'red-light'
                                                    : 'black-light'
                                            }.svg`}
                                        alt={status}
                                    />
                                    <span>
                                        {totalSituationsGlobal[status] ?? '--'}
                                    </span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="customer-detail-body-full">
                        {loading && (
                            <div className="loading-container">
                                <Spinner animation="border" />
                                <p>Carregando unidades...</p>
                            </div>
                        )}

                        {!loading && customers.map(unit => {
                            const isExpanded = expandedUnits[unit.id];
                            const rooms = roomsByUnit[unit.id] || [];

                            return (
                                <div key={unit.id} className="unit-card">
                                    <div
                                        className="unit-card-header"
                                        onClick={() => toggleUnit(unit.id)}
                                    >
                                        <div className="unit-header-texts">
                                            <h4>{unit.name}</h4>
                                            <p>{unit.address}, {unit.phone}</p>

                                            {
                                                unit.spent &&
                                                <p style={{ marginTop: -15, fontSize: '10pt' }}>Consumo: {unit.spent ?? 0}</p>
                                            }
                                        </div>
                                        {/* <div>
                                            {
                                                unit.has_energy && "___"
                                            }
                                            <span className={`collapse-arrow ${isExpanded ? 'expanded' : ''}`}>▾</span>
                                        </div> */}
                                    </div>


                                    <div className="chip-container">
                                        {['SUCCESS', 'WARNING', 'DANGER', 'DARK'].map(status => (
                                            <div
                                                key={status}
                                                className={`chip ${status.toLowerCase()} ${sensorFilter === status ? 'active-item' : ''}`}
                                                onClick={() =>
                                                    setSensorFilter(prev => prev === status ? 'ALL' : status)
                                                }
                                            >
                                                <img
                                                    src={`/media/icons/${status === 'SUCCESS'
                                                        ? 'green-light'
                                                        : status === 'WARNING'
                                                            ? 'yellow-light'
                                                            : status === 'DANGER'
                                                                ? 'red-light'
                                                                : 'black-light'
                                                        }.svg`}
                                                    alt={status}
                                                />
                                                <span>{unit.situations?.[status] ?? '--'}</span>
                                            </div>
                                        ))}
                                    </div>

                                    <div className={`unit-card-body ${isExpanded ? 'expanded' : ''}`}>

                                        {unit.has_energy && <ChartEnergyComponent unit={unit} />}


                                        {loadingRooms[unit.id] && (
                                            <div className="loading-container">
                                                <Spinner animation="border" />
                                                <p>Carregando sensores...</p>
                                            </div>
                                        )}

                                        {!loadingRooms[unit.id] && rooms.map(room => {
                                            const displayedEquipment = filterEquipmentForDisplay(
                                                room.contractItems || []
                                            );

                                            return (
                                                <div key={room.id} style={{ marginTop: -30 }}>

                                                    <RowCards>
                                                        {displayedEquipment
                                                            .filter(item =>
                                                                filterSensorsForDisplay(item.sensors || []).length < 3
                                                            )
                                                            .map((item, idx) => {
                                                                const filteredSensors = filterSensorsForDisplay(item.sensors || []);
                                                                const monitoringItem = { ...item, sensors: filteredSensors };

                                                                return (
                                                                    <ColCard key={idx} colCount={3}>
                                                                        <MonitoringCard item={monitoringItem} />
                                                                    </ColCard>
                                                                );
                                                            })}
                                                    </RowCards>

                                                    <RowCards>
                                                        {displayedEquipment
                                                            .filter(item =>
                                                                filterSensorsForDisplay(item.sensors || []).length >= 3
                                                            )
                                                            .map((item, idx) => {
                                                                const filteredSensors = filterSensorsForDisplay(item.sensors || []);
                                                                const monitoringItem = { ...item, sensors: filteredSensors };

                                                                return (
                                                                    <ColCard key={idx} colCount={2}>
                                                                        <MonitoringCard item={monitoringItem} />
                                                                    </ColCard>
                                                                );
                                                            })}
                                                    </RowCards>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    <Modal
                        show={!!viewSismogran}
                        onHide={() => setViewSismogran()}
                        size="xl"
                        centered
                        scrollable
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <Button variant="outline-secondary" onClick={() => setViewSismogran()}>
                                    ← Voltar
                                </Button>
                                {viewSismogran && (
                                    <Button
                                        variant="success"
                                        className="ml-4"
                                        onClick={() => setFull(!full)}
                                    >
                                        {full ? 'Aumentar Visualização' : 'Reduzir Visualização'}
                                    </Button>
                                )}
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <DetailsMonitoring sensor={viewSismogran} full={full} />
                        </Modal.Body>
                    </Modal>
                </div>
            </div>
        </div>
    );
};

export default DetailClient;
